import { render, staticRenderFns } from "./EditRbuVolumeNameDialog.vue?vue&type=template&id=b9a5c158"
import script from "./EditRbuVolumeNameDialog.vue?vue&type=script&lang=js"
export * from "./EditRbuVolumeNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports